import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';
import imgFallback from 'src/utils/image';

function DescWithTitleAndIcon({ item, grid }) {
  return (
    <Col {...grid} className="py-4">
      <Col>
        <GatsbyImage id={item.image?._key} image={item.image?.image?.asset?.gatsbyImageData ?? imgFallback} alt={item.image?.alt ?? ''} />
      </Col>
      <Col className="font-weight-bold mt-3">{item.title}</Col>
      <Col className="text-muted rfs-size-sm mt-2">
        <PortableText value={item.description} />
      </Col>
    </Col>
  );
}

DescWithTitleAndIcon.propTypes = {
  item: PropTypes.shape({
    _key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    image: PropTypes.shape({}).isRequired,
  }).isRequired,
  grid: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
  }),
};

DescWithTitleAndIcon.defaultProps = {
  grid: PropTypes.shape({}),
};

export default DescWithTitleAndIcon;
